import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteSubscriptionDepartmentMutation, deleteSubscriptionDepartmentMutationVariables } from '../generated/deleteSubscriptionDepartmentMutation';
import { subscriptionDepartmentFieldsFragment } from '../models/SubscriptionDepartment';

/**
 * Get a callback to delete a SubscriptionDepartment in the store.
 */
export function useDeleteSubscriptionDepartmentCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteSubscriptionDepartmentMutation, deleteSubscriptionDepartmentMutationVariables>(
        gql`
            mutation deleteSubscriptionDepartmentMutation ($id: ID!) {
                deleteSubscriptionDepartment(id: $id) {
                    ...subscriptionDepartmentFields
                }
            }

            ${subscriptionDepartmentFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
